import { siteLang as defaultLocale } from "../../config/site-config";

export default (value, options, locale = defaultLocale) => {
  if (!value) return "-- -- --";

  const date = value instanceof Date ? value : new Date(value);

  return new Intl.DateTimeFormat(locale, options).format(date);
};
